import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3C3AEDE0-B6DA-4CB9-A686-869634678D5D
 * name store
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreIcon = createSvgIcon(<><path d="M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z" /></>, 'StoreIcon');
export default StoreIcon